<template>
	<v-container>
		<v-row v-if="$store.getters.getBookmarkedServicePortlets(getPortletsList) && $store.getters.getBookmarkedServicePortlets(getPortletsList).length > 0" class="bookmarks" justify="center">
			<v-col md="6">
				<v-row>
					<v-col v-for="(portlet, index) in $store.getters.getBookmarkedServicePortlets(getPortletsList)" :key="index" cols="12" sm="6">
						<v-card @click="selectPortlet(portlet.id)" class="portlet">
							<v-icon class="bookmark" @click.stop.prevent="bookmark(portlet.id)">mdi-star-outline</v-icon>
							<v-card-title>{{ $t(getTranslation(portlet.id)) }}</v-card-title>
							<v-card-subtitle>{{ $t(getTranslation(portlet.id, 'description')) }}</v-card-subtitle>
							<v-icon class="icon-portlet">{{ icons[portlet.icon] }}</v-icon>
							<v-icon class="goto">mdi-chevron-right</v-icon>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row v-if="$store.getters.getServicePortlets(getPortletsList) && $store.getters.getServicePortlets(getPortletsList).length > 0" justify="center">
			<v-col md="6">
				<v-row>
					<v-col v-for="(portlet, index) in $store.getters.getServicePortlets(getPortletsList)" :key="index" cols="12" sm="6">
						<v-card @click="selectPortlet(portlet.id)" class="portlet">
							<v-icon class="bookmark" @click.stop.prevent="bookmark(portlet.id)">mdi-star-outline</v-icon>
							<v-card-title>{{ $t(getTranslation(portlet.id)) }}</v-card-title>
							<v-card-subtitle>{{ $t(getTranslation(portlet.id, 'description')) }}</v-card-subtitle>
							<v-icon class="icon-portlet">{{ icons[portlet.icon] }}</v-icon>
							<v-icon class="goto">mdi-chevron-right</v-icon>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import { api } from '@/utils/api';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
	data () {
		return {
			icons: {
				shippingOrder: 'mdi-map-marker-path',
				product: 'mdi-tag',
				clientOrder: 'mdi-clipboard-text-outline',
				handlingUnit: 'mdi-package-variant-closed',
				prepOrder: 'mdi-dolly'
			}
		};
	},
	computed: {
		...mapGetters(['getPortletsList', 'getCurrentClientId']),
		...mapState({
			portletsBookmarks: state => state.clients.portletsBookmarks,
			serviceName: state => state.clients.service,
			clientId: state => state.clients.current
		})
	},
	methods: {
		...mapMutations(['setGSPortlets', 'setGSPortletId', 'setPortletBookmark', 'setPortletsBookmarks']),
		getTranslation (portletId, refType = 'name') {
			const key = `genericSearch.${this.getCurrentClientId}.${portletId}.${refType}`;
			return this.$te(key) ? this.$t(key) : this.$t(`genericSearch.default.${refType}`);
		},
		async getPortlets () {
			if (this.clientId) {
				const portlets = await api.get('allPortlets', { idClient: this.clientId }, null, 'genericsearch');
				this.setGSPortlets(portlets);
			}
		},
		selectPortlet (id) {
			this.setGSPortletId(id);
			this.$router.push(`/${this.$store.getters.getClientName}/genericsearch/${id}`);
		},
		getClientId () {
			return this.$store.getters.getCurrentClientId;
		},
		async bookmark (id) {
			this.setPortletBookmark(id);
			const currentPoBookmark = this.portletsBookmarks.find(pBookmark => pBookmark.idClient === this.clientId && pBookmark.serviceName === this.serviceName && pBookmark.portletId === id);

			if (currentPoBookmark) {
				await api.post(['bookmarks', 'togglePortletBookmark'], null, currentPoBookmark, null);
			}
		},
		async getBookmarkedPortlets () {
			if (this.clientId && this.serviceName) {
				const bookmarkedPortlets = await api.get(['bookmarks', 'getBookmarkedPortlets'], { idClient: this.clientId, serviceName: this.serviceName });
				this.setPortletsBookmarks(bookmarkedPortlets);
			}
		}
	},
	async mounted () {
		await this.getPortlets();
		await this.getBookmarkedPortlets();
		if (this.getPortletsList && this.getPortletsList.length === 1) {
			this.selectPortlet(this.getPortletsList[0].id);
		}
	},
	watch: {
		clientId: function () {
			this.getPortlets();
			this.getBookmarkedPortlets();
		}
	}
};

</script>
<style lang="scss" scoped>

@import "@/scss/_colors.scss";


.portlet {
	cursor: pointer;
	border-top: 7px solid #fff;
	.goto {
		color: $primary;
		border-radius: 50% !important;
		position: absolute;
		right: 10px;
		bottom: 20px;
	}
	&:hover {
		border-top: 7px solid $primary;
		.goto {
			background-color: $primary;
			color: #fff;
		}
	}
}
.icon-portlet {
	margin: 0 16px 20px;
	height: 24px;
	width: 24px;
	color: $lighter-grey;
}
.bookmark {
		color: $lighter-grey;
		position: absolute;
		right: 10px;
		top: 20px;
		&:hover {
			color: $yellow;
		}
	}
	.bookmarks {
	margin-bottom: 30px;
	.bookmark {
		color: $yellow !important;
	}
}
</style>
